export default __webpack_public_path__ + "static/media/close loan.1de23318.svg";